module.exports = __webpack_public_path__ + "static/media/portugal.ada259b5.svg";